<template>
  <div>
    <!-- 选择车辆部分 -->
    <QS-h4-title title="选择车辆" />
    <el-form ref="vehicleFormRef" :model="formModel" :rules="formRules" class="mt16 form-box" label-position="top">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="车牌号" prop="carId">
            <template v-if="isRenew && hasOriginOrderId">
              {{ formModel.plateNo }}
            </template>
            <template v-else>
              <QS-select
                v-model="formModel.carId"
                placeholder="请输入车牌号"
                filterable
                remote
                clearable
                :remote-method="getPlateNoList"
                :option-data="plateNoList"
                :option-config="{labelKey: 'plateNo', valueKey: 'id'}"
                :loading="loading.carSearch"
                @change="carIdChange"
                popper-class="car-choose-select-list"
              >
              </QS-select>
              <div class="mt8" v-if="!isRenew">
                <el-link type="primary" :underline="false" @click="goToCreateCar">
                  找不到车辆?点击新增
                </el-link>
              </div>
            </template>
          </el-form-item>
        </el-col>
        <!-- 续约时不显示品牌 车系 车型 车辆状态等信息-->
        <template v-if="isRenew">
          <el-col :span="8">
            <el-form-item label="原订单ID">
              <span class="form-text">{{ originalOrderId || formModel.relatedOrderId || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="司机姓名">
              <span class="form-text">{{ formModel.customerName || '--' }}</span>
            </el-form-item>
          </el-col>
        </template>
        <template v-else>
          <el-col :span="8">
            <el-form-item label="品牌">
              <span class="form-text">{{ carInfo.brandName || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车系">
              <span class="form-text">{{ carInfo.seriesName || '--' }}</span>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <el-row :gutter="24" v-if="!isRenew">
        <el-col :span="8">
          <el-form-item label="车型">
            <span class="form-text">{{ carInfo.modelName || '--' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="车辆状态">
            <span v-if="carState.type === 'success'" class="form-text">{{ carState.text || '--' }}</span>
            <div v-else class="form-box__state">
              <span class="form-box__state__fail">{{ carState.text }}</span>
              <span>（{{ carState.reason }}）</span>
              <el-button
                type="primary"
                size="small"
                class="form-box__state__operate"
                @click="handleUnavailable">点击处理</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch, reactive, onUnmounted, nextTick } from 'vue'
import { useFormSync, useRoute } from '@/utils/useUtils.js'
import { getSimpleCarList, getCarDetailById } from '@/api/carManage/index.js'
import WindowCommunication from '@/utils/windowCommunication'
import { getOrderDetail } from '@/api/domain/carsService.js'
import { getRentOrderIds } from '@/api/domain/underLease.js'
import { miniStore } from '@/miniStore'
import { storeDetail } from '@/api/domain/shop.js'
import { ORDER_SOURCE } from '@/config/rentConfig.js'
import { Message } from '@qs/ui'
import { quick } from '@/utils/ba'

const props = defineProps({
  isRenew: {
    type: Boolean,
    default: false,
  },
})
const { formModel } = useFormSync('step0')

const route = useRoute()
const formRules = {
  carId: [{ required: true, message: '请选择车牌号', trigger: 'change' }],
}

const hasOriginOrderId = ref(false)

// 表单引用
const vehicleFormRef = ref(null)

// 车牌号列表
const plateNoList = ref([])
const loading = reactive({
  carSearch: false,
})
// 车辆信息
const carInfo = ref({})
// 原订单ID
const originalOrderId = ref('')
const emit = defineEmits(['updateModelId', 'getOriginInfo', 'clearDriverInfo'])

// 车牌号远程搜索
const getPlateNoList = async (query) => {
  if (query.trim().length < 1) {
    return
  }
  getCarList(query.trim())
}

const getCarList = async (query) => {
  loading.carSearch = true
  try {
    const { code, data } = await getSimpleCarList({
      plateNo: query,
      state: props.isRenew ? 2 : 5, // 2-运营中车辆，5-运营中车辆不包含已租
      modelId: isECommerce.value ? formModel.modelId : null,
    })
    if (code === 1) {
      plateNoList.value = data || []
    }
  } finally {
    loading.carSearch = false
  }
}

// 车牌号清空时，清除页面信息
const clearCarRelatedInfo = () => {
  carInfo.value = {}
  getCarList()
  if (props.isRenew) {
    originalOrderId.value = ''
    miniStore.dispatch({
      type: 'BATCH_UPDATE_FIELD',
      payload: {
        updates: {
          step0: {
            rentCategory: '',
            customerName: '',
            presentDays: 0,
            payMode: '',
            contractTemplateId: '',
            templateName: '',
            storeId: '',
            storeName: '',
            signDate: '',
            contractEndDate: '',
            planId: 0,
            modelId: '',
            cityCode: '',
            relatedOrderId: '',
            isTranDeposit: 0,
          },
        },
      },
    })
  } else {
    miniStore.dispatch({
      type: 'BATCH_UPDATE_FIELD',
      payload: {
        updates: {
          step0: {
            brandId: '',
            seriesId: '',
            modelId: '',
          },
        },
      },
    })
  }
}
const carIdChange = async (carId) => {
  if (!carId) {
    nextTick(() => {
      clearCarRelatedInfo()
    })
    return
  }
  if (props.isRenew) {
    getOriginalOrderId(carId)
  } else {
    await getCarInfo(carId)
    emit('updateModelId', carInfo.value.modelId)
  }
}
// 获取车辆相关信息
const getCarInfo = async (carId) => {
  const { orderId } = route.query
  const { data } = await getCarDetailById({ carId, orderId })
  if (!data.plateNo) {
    return
  }
  carInfo.value = data || {}
  miniStore.dispatch({
    type: 'BATCH_UPDATE_FIELD',
    payload: {
      updates: {
        step0: {
          brandId: data.brandId,
          seriesId: data.seriesId,
          modelId: data.modelId,
        },
      },
    },
  })
}
// 续约时，获取原订单id
const getOriginalOrderId = async (carId) => {
  const { code, data } = await getRentOrderIds({
    carId,
    orderBizType: 10,
    orderStates: [2500],
  })
  if (code === 1) {
    if (Array.isArray(data) && data.length) {
      // 如果只有一个订单则自动填充
      if (data.length === 1) {
        originalOrderId.value = data[0]?.id
        getOrderDetailById(originalOrderId.value)
      }
    } else {
      Message.warning('车牌号无履约中状态订单，无法续约')
    }
  }
}
const getOrderDetailById = async (orderId) => {
  const { code, data } = await getOrderDetail({ orderId })
  if (code === 1) {
    const {
      rentCategory,
      customerName,
      payMode,
      templateId,
      templateName,
      storeId,
      storeName,
      depositReceivedVO,
      signDate,
      contractEndDate,
      planId,
      modelId,
    } = data || {}
    // 通过门店ID获取门店详情，从而获取cityCode
    const { data: storeDetailInfo } = await storeDetail({ id: storeId })
    const { cityCode } = storeDetailInfo.storeVO
    miniStore.dispatch({
      type: 'BATCH_UPDATE_FIELD',
      payload: {
        updates: {
          step0: {
            rentCategory,
            customerName,
            presentDays: data.presentDays || 0,
            payMode,
            contractTemplateId: templateId,
            templateName,
            storeId,
            storeName,
            depositReceivedVO,
            signDate,
            contractEndDate,
            planId,
            modelId,
            cityCode,
            relatedOrderId: orderId,
            isTranDeposit: data.depositReceivedVO?.flag ? 1 : 0,
          },
        },
      },
    })
    emit('getOriginInfo', data)
  }
}
// 车辆状态
const carState = computed(() => {
  const { unavailableType, lockedOrderId, id, plateNo, lockedOrderBizType } = carInfo.value
  if (!id) {
    return {
      type: 'success',
      text: '--',
    }
  }
  if (!unavailableType) {
    return {
      type: 'success',
      text: '可发',
    }
  }

  // 50001 命中待租条件-证照状态不可发
  // 50002 命中待租条件-不可租标签
  // 50003 命中待租条件-车务状态监控的开启检查项
  // 50004 已绑定订单-订单已锁定
  // 50005 已绑定订单-订单换车锁定
  const unavailableMap = {
    50001: {
      reason: '车辆证照信息不全',
      link: `/vehicle/vehicleManage/allEdit?scene=1&id=${id}`,
    },
    50002: {
      reason: '车辆异常',
      link: `/car_to_lease/notSentCarList?scene=1&id=${id}&plateNo=${plateNo}`,
    },
    50003: {
      reason: '车况状态异常',
      link: `/car_to_lease/notSentCarList?scene=1&id=${id}&plateNo=${plateNo}`,
    },
    50004: {
      lockedOrderBizType,
      reason: '已绑定其他订单',
      link: `/workbench/rentOrder/list?scene=1&attributeId=${lockedOrderId}`,
      entLink: `/workbench/entOrder/list?scene=1&attributeId=${lockedOrderId}&listType=child`,
      lockedOrderId,
    },
    50005: {
      reason: '已绑定其他订单',
      link: `/workbench/rentOrder/list?scene=1&orderId=${lockedOrderId}`,
      lockedOrderId,
    },
  }
  return {
    type: 'fail',
    text: '不可发',
    ...unavailableMap[unavailableType],
  }
})
const handleUnavailable = () => {
  quick('click', 'personal_sign_contract_unavailable', {
    unavailableType: carInfo.value.unavailableType,
    lockedOrderId: carInfo.value.lockedOrderId,
    lockedOrderBizType: carInfo.value.lockedOrderBizType,
  })
  const { link, lockedOrderBizType, entLink } = carState.value
  let jumpLink = link
  if (lockedOrderBizType === 10) {
    jumpLink = link
  } else if (lockedOrderBizType === 20) {
    jumpLink = entLink
  }
  const newWindow = window.open(jumpLink, '_blank')
  const currentWindow = window

  if (newWindow) {
    newWindow.addEventListener('beforeunload', () => {
      setTimeout(() => {
        currentWindow.focus()
      }, 100)
    })
  }
}

// 车辆状态处理后消息处理，刷新车辆状态
const handleUnavailableMessage = (data) => {
  // 如果是订单相关的，需要判断订单id是否一致；非订单类即不可发车辆状态处理的，不用进行订单ID判断
  if ((carState.value.lockedOrderId && data === carState.value.lockedOrderId) || data) {
    // 更新车辆状态
    getCarInfo(carInfo.value.id)
  }
}

const goToCreateCar = () => {
  quick('click', 'personal_sign_contract_add_car')
  const newWindow = window.open('/vehicle/vehicleManage/add?scene=1', '_blank')
  const currentWindow = window

  if (newWindow) {
    newWindow.addEventListener('beforeunload', () => {
      setTimeout(() => {
        currentWindow.focus()
      }, 100)
    })
  }
}

// 新增车辆后消息处理，选中刚刚添加的车辆并且刷新车辆状态
const handleAddCar = async (data) => {
  if (data) {
    // 更新车辆状态
    await carIdChange(data)
    if (!carInfo.value.plateNo) {
      return
    }
    plateNoList.value = [carInfo.value]
    formModel.carId = carInfo.value.id
    miniStore.dispatch({
      type: 'BATCH_UPDATE_FIELD',
      payload: {
        updates: {
          step0: {
            carId: carInfo.value.id,
          },
        },
      },
    })
  }
}

const validateForm = async () => {
  if (!vehicleFormRef.value) return false
  try {
    const valid = await vehicleFormRef.value.validate()
    return valid
  } catch (error) {
    return false
  }
}

const handleUrlPlateNo = async (plateNo) => {
  // 如果url中有车牌号(车辆列表进入），正常回填，或者上一步传递车牌号
  const carPlateNo = plateNo || route.query.plateNo
  // 如果服务端返回数据中有车牌号和车辆id，直接组成数组，不用再请求车辆列表接口，解决先回显ia后显示车牌号问题
  if (formModel.plateNo && formModel.carId) {
    plateNoList.value = [{ plateNo: formModel.plateNo, id: formModel.carId }]
    getCarInfo(formModel.carId)
  } else if (carPlateNo) {
    await getPlateNoList(carPlateNo)
    const carId = plateNoList.value[0]?.id
    if (!carId) {
      return
    }
    miniStore.dispatch({
      type: 'BATCH_UPDATE_FIELD',
      payload: {
        updates: {
          step0: {
            carId,
          },
        },
      },
    })
    getCarInfo(carId)
  } else {
    getCarList()
  }
}
const initData = (plateNo) => {
  handleUrlPlateNo(plateNo)
  vehicleFormRef.value?.clearValidate()
}

// 判断是否为商城单（绑车）
const isECommerce = computed(() => {
  return formModel.source === ORDER_SOURCE.E_COMMERCE && !props.isRenew
})

const communication = ref(null)

watch(() => isECommerce.value, (val) => {
  if (val) {
    carInfo.value = {
      brandName: formModel.brandName,
      seriesName: formModel.seriesName,
      modelName: formModel.modelName,
    }
  }
}, { immediate: true })

// 在组件卸载时移除监听
onUnmounted(() => {
  if (communication.value) {
    communication.value.off('unavailable_message', handleUnavailableMessage)
    communication.value.off('add_car', handleAddCar)
    communication.value.destroy()
  }
})

onMounted(() => {
  // 车辆不可发状态处理
  communication.value = new WindowCommunication('person_sign_contract')
  communication.value.on('unavailable_message', handleUnavailableMessage)
  // 新增车辆
  communication.value.on('add_car', handleAddCar)
  handleUrlPlateNo()
  if (route.query.oldOrderId) {
    hasOriginOrderId.value = true
  }
})

defineExpose({
  validateForm,
  initData,
})
</script>

<style lang="scss" scoped>

.form-text {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  color: #606266;
  font-size: 14px;
}

.mt16 { margin-top: 16px; }
.form-box {
  ::v-deep .el-form-item .el-form-item__label {
    justify-content: flex-start;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-input {
    width: 100%;
  }
  &__state {
    display: flex;
    align-items: center;
    &__fail {
      color: #F53F3F;
    }
    &__operate {
      margin-left: 12px;
      height: 24px;
      color: #fff;
      padding: 0 8px;
    }
  }
}
</style>
<style lang="scss">
.car-choose-select-list {
  .el-select-dropdown__wrap {
    width: 100% !important;
    .qs-select-dropdown__item {
      max-width: 100% !important;
    }
  }
}
</style>
